import {
  BaseEdge,
  EdgeLabelRenderer,
  getStraightPath,
  getSmoothStepPath,
  getBezierPath,
  useReactFlow,
} from 'reactflow';

export default function CustomEdge({ id, sourceX, sourceY, targetX, targetY, animated }) {
  const { setEdges } = useReactFlow();
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      {/* <BaseEdge id={id} path={edgePath} /> */}
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: '#4924CE',
          strokeWidth: 1,
          strokeDasharray: animated ? '6,6' : 'none',
          animation: animated ? 'dashmove 1s linear infinite' : 'none',
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',            
            padding: '4px',
            borderRadius: '50%',            
            cursor: 'pointer',
          }}
          className="nodrag nopan"
          onClick={() => {
            setEdges((es) => es.filter((e) => e.id !== id));
          }}
        >
          <i className="ri-close-line"></i>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
